module.exports = __webpack_public_path__ + "img/slides-image@2x.e5164014.png";